<template lang="html">
    <div class="section-yellow text-center py-5">
        <div class="container">
            <div v-html="msg">

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PromoRandom',
    components: {
    },
    props: {
        msg: ''
    },
    computed: {
    },
    data: function() {
        return {}
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>

.container  {
    font-style: italic;
    font-size: 140%;
}

</style>
